<script setup lang="ts">
import DefaultLayout from './layouts/DefaultLayout.vue'
import FooterBar from './layouts/FooterBar.vue'
</script>

<template>
  <DefaultLayout />
  <main class="main-content">
    <router-view />
  </main>
  <FooterBar />
</template>

<style scoped>
.main-content {
  padding-top: 64px;
  min-height: calc(100vh - 200px);
}
</style>
